import React from "react";
import TripAdvisorLogo from "../../resources/images/TripAdvisor_Logo.svg.png";

const TripAdvisorImgCard = () => {
  return (
    <div>
      {" "}
      <div className="shadow-lg p-8 rounded-lg">
        <h1 className="text-primary-base font-bold">CUSTOMERS REVIEWS</h1>
        <hr className="my-3" />
        <a
          href="https://www.tripadvisor.com/Attraction_Review-g424934-d10854407-Reviews-Himalayan_Ultimate_Trekking_Nepal-Bhaktapur_Kathmandu_Valley_Bagmati_Zone_Centra.html"
          target="_blank"
        >
          <img src={TripAdvisorLogo} alt="" className="w-[80%]" />
        </a>
      </div>
    </div>
  );
};

export default TripAdvisorImgCard;
